import flatten from 'flat';
import organizationSettings from './fr-FR/organizationSettings';
import settings from './fr-FR/settings';

export default flatten({
  ...organizationSettings,
  ...settings,
});
